import {
    DataLoadedAction,
    ErrorLoadingDataAction,
    LoadingDataAction,
    SetTimeAction,
    TemplateLoadedAction,
    TypeKeys,
} from '../../state-management/widgetblock/actions/types';
import { Data, MandateProps } from '../types';
import { DataTableConfigBlockState, DataTableState } from './types';
import mergeTemplateAndData from './utils/mergeTemplateAndData';

type Actions = LoadingDataAction | TemplateLoadedAction<DataTableConfigBlockState> | ErrorLoadingDataAction | SetTimeAction | DataLoadedAction<Data[]>;

type RequiredDataTableState = MandateProps<DataTableState, 'datasets' | 'viewblockState' | 'time'>;

const INITIAL_STATE: DataTableState = {
    datasets: null,
    viewblockState: null,
};

const checkIfEverythingLoaded = (state: DataTableState) => Boolean(state.datasets && state.viewblockState && state.time);

const checkIfEverythingLoadedAndRunFunc = (state: DataTableState, func: (state: RequiredDataTableState) => DataTableState) =>
    checkIfEverythingLoaded(state) ? func(state as RequiredDataTableState) : state;

const reducer = (state = INITIAL_STATE, action: Actions) => {
    switch (action.type) {
        case TypeKeys.LOADING_DATA:
            return { ...state, isLoadingData: true };

        case TypeKeys.ERROR_LOADING_DATA:
            return { ...state, isLoadingData: false };

        case TypeKeys.SET_TIME: {
            const { iso8601, timezone } = action.payload;

            state = { ...state, time: { iso8601, timezone } };

            return checkIfEverythingLoadedAndRunFunc(state, mergeTemplateAndData);
        }

        case TypeKeys.TEMPLATE_LOADED:
            return checkIfEverythingLoadedAndRunFunc({ ...state, viewblockState: action.payload.data }, mergeTemplateAndData);

        case TypeKeys.DATA_LOADED: {
            const datasets = [...action.payload.data];

            if (state.datasets) {
                state.datasets.forEach((existing) => {
                    if (datasets.findIndex((d) => d.datasetId === existing.datasetId) < 0) {
                        datasets.push(existing);
                    }
                });
            }

            datasets.sort((d1, d2) => `${d2.datasetId}__${d2.capabilityId}`.localeCompare(`${d1.datasetId}__${d1.capabilityId}`));

            return checkIfEverythingLoadedAndRunFunc({ ...state, datasets, isLoadingData: false }, mergeTemplateAndData);
        }

        default:
            return state;
    }
};

export default reducer;
